<template>
  <div
    class="gj-table pb-0 vh-100 w-100 d-flex flex-column overflow-hidden"
  >
    <div class="d-flex flex-row h-100 flex-grow-1 auth-inner m-0 bg-white">
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="7"
        class="d-none d-lg-flex align-items-center p-0 bg-white login-carousel"
      >
        <b-carousel
          id="carousel-1"
          :interval="5000"
          controls
          style="height: 100%; width: 100%;"
        >
          <b-carousel-slide
            v-for="slide in slides"
            :key="slide.text"
            style="height: 100%"
          >
            <template #img>
              <!-- linear-gradient(13.18deg, #F26822 -14.33%, rgba(4, 24, 43, 0) 127.67%),  -->
              <div
                class="img-fluid w-100 h-100 d-block"
                :style="`background-image: url(${slide.src}); background-size: cover; background-repeat: no-repeat;`"
              />
            </template>
            <h2 class="text-light text-capitalize">
              {{ slide.text }}
            </h2>
          </b-carousel-slide>
        </b-carousel>
      </b-col>
      <b-col
        lg="5"
        class="d-flex align-items-center auth-bg px-2 p-lg-5 bg-transparent"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto text-center"
        >
          <b-col
            class=""
            style="position: relative; display: block;"
          >
            <b-img
              :src="vpLogoDark"
              alt="logo"
              class="mx-auto d-flex mb-2"
              style="height: 30px;"
            />
          </b-col>
          <h4 class="text-secondary">
            Sign In to VP Player
          </h4>
          <b-card-text class="mb-2 text-secondary text-shadow">
            Please sign-in to your account and start the adventure
          </b-card-text>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <b-button
                variant="primary"
                class="w-auto px-2 "
                block
                :disabled="invalid"
                @click="authenticateOidc"
              >
                <span class="text-main">
                  Continue to Sign In
                </span>
              </b-button>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  ValidationObserver,
} from 'vee-validate'
import { required, email } from '@validations'
import { mapActions } from 'vuex'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import { $themeConfig } from '@themeConfig'
import ToastificationContent from '@toastification'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { OIDC_STORE_MODULE, authenticate } from '@/auth'
import useJwt from '@/auth/jwt/useJwt'
// import Sphere from '@/components/outsources/LoginSpherePlayer.vue'

export default {
  components: {
    // Sphere,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: 'admin',
      userEmail: 'admin@demo.com',
      sideImg: '',
      logo: '',

      // validation rules
      required,
      email,
      slides: [
        { src: 'https://vp.gjirafa.net/admin/slide-1.png?width=800', text: 'Every business is unique' },
        { src: 'https://vp.gjirafa.net/admin/slide-2.png?width=800', text: 'advanced features for real-time streaming' },
        { src: 'https://vp.gjirafa.net/admin/slide-3.png?width=800', text: 'earn easily & quickly' },
        { src: 'https://vp.gjirafa.net/admin/slide-4.png?width=800', text: 'Build your own medium' },
      ],
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = ''
        return this.sideImg
      }
      return this.sideImg
    },
  },
  setup() {
    // App Name
    const { appName, vpLogoDark, vpShort } = $themeConfig.app

    return {

      // App Name
      appName,
      vpLogoDark,
      vpShort,
    }
  },
  created() {
    const payload = this.$route.query.redirectTo || '/'
    authenticate(payload)
      .catch(() => {})
  },
  methods: {
    ...mapActions(OIDC_STORE_MODULE, [
      'authenticateOidc', // Authenticates with redirect to sign in if not signed in
    ]),
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
          })
            .then(response => {
              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      // title: `Welcome ${userData.fullName || userData.username}`,
                      icon: 'Home',
                      variant: 'success',
                      text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                    },
                  })
                })
                .catch(error => {
                  this.$refs.loginForm.setErrors(error.response.data.error)
                })
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

.text-shadow {
  text-shadow: 5px 0px 5px rgba(200, 200, 200, 0.8);
}

.login-carousel {
  .carousel-control-prev {
    right: 90px;
    left: unset;
  }
  .carousel-control-next {
    right: 30px;
  }
  .carousel-control-prev, .carousel-control-next {
    width: 40px;
    height: 40px;
    line-height: 0;
    border: 2px solid white;
    border-radius: 50%;
    bottom: 30px;
    top: unset;
  }
  .carousel-inner {
    height:100%;
    position: relative !important;
  }
  .carousel-caption {
    text-align: left !important;
    left: 5% !important;
    bottom: 50px !important;
  }
}

</style>
